export const PERSIST_KEY_BASE = 'persistantState';

export function persistKeyForServerName(
  serverName: string | undefined,
  isProd: boolean
): string {
  if (isProd) return PERSIST_KEY_BASE;
  const [platform, core] = (serverName ?? '').split('.');
  if (!platform || !core) return PERSIST_KEY_BASE;
  return `${PERSIST_KEY_BASE}-${platform}-${core}`;
}
